import React from 'react';
import {
  formatTimelineDate,
  formatTimelineDateTime,
  getStageExtraLine,
  getStageSubtitle,
  getTimelineCurrentIndex,
  resolveStatusTimeline,
  STAGE_DISPLAY_LABELS,
} from '../../Utils/partnerTimelineUtils';

const TimelineDocIcon = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
    <path
      d="M4.5 1.5h5.2l2.8 2.8v9.9c0 .6-.5 1.1-1.1 1.1h-6.9c-.6 0-1.1-.5-1.1-1.1V2.6c0-.6.5-1.1 1.1-1.1Z"
      fill="currentColor"
    />
    <path d="M9.5 1.8V4c0 .3.2.5.5.5h2.2" fill="none" stroke="currentColor" strokeWidth="1.1" />
  </svg>
);

const ProjectStatusTimeline = ({ project }) => {
  const statusTimeline = resolveStatusTimeline(project);
  const currentStepIndex = getTimelineCurrentIndex(statusTimeline, project);

  if (!statusTimeline.length) {
    return <p className="partner-project-timeline-empty">Status timeline is not available yet.</p>;
  }

  return (
    <>
      <div className="partner-project-timeline">
        {statusTimeline.map((stage, index) => {
          const isDone = stage.completed;
          const isCurrent = index === currentStepIndex;
          const isPending = !isDone && !isCurrent;
          const label = STAGE_DISPLAY_LABELS[stage.stage] || stage.stage;
          const subtitle = getStageSubtitle(stage.stage, project, { isDone, isCurrent });
          const extraLine = getStageExtraLine(stage.stage, project, { isCurrent });
          const dateText = isDone && stage.completedAt
            ? (stage.stage === 'Submitted'
              ? formatTimelineDateTime(stage.completedAt)
              : formatTimelineDate(stage.completedAt))
            : '';

          return (
            <div
              key={`${stage.stage}-${index}`}
              className={`partner-project-timeline-item ${isPending ? 'is-pending' : ''} ${isCurrent ? 'is-current-step' : ''}`}
            >
              <div
                className={`partner-project-timeline-marker ${isDone ? 'is-done' : ''} ${isCurrent ? 'is-current' : ''} ${isPending ? 'is-pending' : ''}`}
              >
                {isDone ? <TimelineDocIcon /> : null}
                {isCurrent ? <span className="partner-project-timeline-now">NOW</span> : null}
              </div>
              <div className="partner-project-timeline-content">
                <h6>{label}</h6>
                {subtitle ? <p className="partner-project-timeline-subtitle">{subtitle}</p> : null}
                {dateText ? <p className="partner-project-timeline-date">{dateText}</p> : null}
                {extraLine ? <p className="partner-project-timeline-extra">{extraLine}</p> : null}
              </div>
            </div>
          );
        })}
      </div>
      <a className="partner-project-detail-contact" href="mailto:support@helixops.ai">
        Questions? Contact your PAE →
      </a>
    </>
  );
};

export default ProjectStatusTimeline;
